/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function getNewMultipleValue(_ref) {
  var id = _ref.id,
    value = _ref.value;
  var newValue;
  var isArray = Array.isArray(value);
  var hasValue = isArray && value.indexOf(id) !== -1;
  if (hasValue) {
    newValue = value.filter(function (itemId) {
      return itemId !== id;
    });
    newValue = newValue.length ? newValue : null;
  } else {
    newValue = isArray ? [].concat((0, _toConsumableArray2.default)(value), [id]) : [id];
  }
  return newValue;
}
var _default = getNewMultipleValue;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/getNewMultipleValue.js
// module id = 666
// module chunks = 0